import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { UtilsService } from 'app/shared/utils.service';
import * as JSZip from 'jszip';
import {
  S3FileInput,
  FileTypeEnum,
  GetAnswerQuery,
  StandardType,
  ModelArtifactsRegistryFilterInput,
  ArtifactStatus,
} from 'app/API.service';
import { FileService } from '../../../shared/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { CollectionService } from 'app/collection/collection.service';
import { CUSTOMAPIService } from 'app/custom-api.service';
import { AdditionalRequirements } from 'app/shared/enums/common.enum';
import { VendorFrameworkNamePipe } from 'app/shared/pipes/vendor-framework-name.pipe';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'cygov-collection-question-link-upload',
  templateUrl: './collection-question-link-upload.component.html',
  styleUrls: ['./collection-question-link-upload.component.scss'],
  standalone: false,
})
export class CollectionQuestionLinkUploadComponent implements OnInit {
  @Input() answerDetails: GetAnswerQuery;
  @Input() question: any; // Full question object
  @Input() frameworkName: string; // Framework name (can be extracted from question if needed)
  @Input() skipUpload: boolean = false; // Flag to skip automatic upload
  @Input() pathList: string[] = []; // Path list from collection-overview-tabs component
  @Input() questionNumber: number = 0; // Question number to display

  // Extracted values from question object
  controlName: string = '';
  questionText: string = '';
  // Path display properties
  @ViewChild('questionTextElement', { static: false }) questionTextElement?: ElementRef<HTMLDivElement>;
  path: string = '';
  pathForToolTip: string = '';
  frameworkKey: string = '';
  isVendorUser: boolean = false;
  isFirstParty: boolean = false;
  @Output() closeUpload = new EventEmitter<boolean>();
  @Output() closeModalClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saveFiles = new EventEmitter<any>();
  @Output() filesSelected = new EventEmitter<File[]>(); // Emit files before upload
  // Emit selected artifact IDs and artifacts data
  @Output() artifactsLinked = new EventEmitter<{ artifactIds: string[]; artifacts: any[] }>();

  uploader: FileUploader = new FileUploader({ url: 'path_to_api' });
  startUpload = true;
  filesToUnUpload: File[] = [];
  totalUploaded = 0;
  progressBars = {};
  uploadModalScreen = true;
  zipSaved = false;
  DOCX: string = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  // Artifacts registry properties
  artifacts: any[] = [];
  filteredArtifacts: any[] = [];
  selectedArtifacts: Set<string> = new Set();
  artifactSearchText: string = '';
  sortOrder: 'latest' | 'oldest' = 'latest';
  isDropdownOpen: boolean = false;
  previousSortOrder: 'latest' | 'oldest' = 'latest';
  isSelecting: boolean = false;
  isLoadingArtifacts: boolean = false;

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private fileService: FileService,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private logger: NGXLogger,
    private collectionService: CollectionService,
    private customApi: CUSTOMAPIService,
    private cdr: ChangeDetectorRef,
    private vendorNamePipe: VendorFrameworkNamePipe
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isSelecting) {
      const target = event.target as HTMLElement;
      if (!target.closest('.sort-dropdown-container')) {
        this.isDropdownOpen = false;
        this.cdr.detectChanges();
      }
    }
  }

  ngOnInit(): void {
    console.log('question', this.question);
    // Extract values from question object
    if (this.question) {
      this.controlName = this.question.controlName || '';
      this.questionText = this.question.name || this.question.title;
      this.frameworkName = this.question.standards || '';
    }

    // Initialize user type flags
    this.isFirstParty = this.router.url.includes('first-party');
    this.isVendorUser = this.collectionService.getIsVendor();

    // Format and display the path
    this.initializePath();

    this.fetchArtifacts();

    console.log(this.pathList, 'pathList');
  }

  /**
   * Formats the pathList similar to collection-overview-tabs component
   */
  initializePath(): void {
    if (!this.pathList || this.pathList.length === 0) {
      return;
    }

    const pathList = [...this.pathList]; // Make a copy to avoid modifying the original

    this.frameworkKey = pathList[0];
    pathList.splice(-1, 1); // Remove last element
    pathList.splice(0, 1); // Remove first element
    const toolTipPathList = [...pathList];

    const frameworkNameFromPath = pathList[0];
    let displayFrameworkName = frameworkNameFromPath;

    if (this.isVendorUser) {
      displayFrameworkName = frameworkNameFromPath.toUpperCase();
      toolTipPathList[0] = frameworkNameFromPath.toUpperCase();
      if (displayFrameworkName === StandardType.COMPLIANCE_FRAMEWORK) {
        displayFrameworkName = AdditionalRequirements.CERTIFICATIONS.toUpperCase();
        toolTipPathList[0] = AdditionalRequirements.CERTIFICATIONS.toUpperCase();
      } else if (displayFrameworkName === StandardType.ARTIFACT) {
        displayFrameworkName = AdditionalRequirements.REQUIREMENTS.toUpperCase();
        toolTipPathList[0] = AdditionalRequirements.REQUIREMENTS.toUpperCase();
      }
    }

    // Subentity name is not shown in the path
    // if (this.collectionService.getShowAllFrameworks()) {
    //   pathList.unshift(this.stripHtml(subEntity.name));
    // }

    if (!this.isFirstParty || this.isVendorUser) {
      const transformedName = this.vendorNamePipe.transform(displayFrameworkName);
      toolTipPathList[0] = transformedName;
      pathList[0] = transformedName;
    }

    this.pathForToolTip = toolTipPathList.join(' | ');
    const divider = '&nbsp;&nbsp;|&nbsp;&nbsp;';
    this.path = pathList.join(divider);
  }

  /**
   * Strips HTML tags from a string
   */
  stripHtml(html: string): string {
    if (!html) {
      return '';
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }

  /**
   * Fetches all artifacts for the current entity from the API
   */
  async fetchArtifacts(): Promise<void> {
    const entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
    if (!entityId) {
      console.warn('Entity ID not found, skipping artifact fetch');
      return;
    }

    try {
      this.isLoadingArtifacts = true;
      const allApiItems: any[] = [];
      let nextToken: string | null | undefined = null;

      // Filter for top-level artifacts with OPEN status
      const filter: ModelArtifactsRegistryFilterInput = {
        parentID: { attributeExists: false },
      };

      do {
        const response = await this.customApi.ArtifactsByEntityId(
          entityId,
          undefined,
          filter,
          500,
          nextToken || undefined
        );

        if (response?.items) {
          allApiItems.push(...response.items);
        }

        nextToken = response?.nextToken;
      } while (nextToken);

      // Filter only top-level artifacts (no parent) and exclude ARCHIVED status
      this.artifacts = allApiItems
        .filter(item => item.status !== ArtifactStatus.ARCHIVED)
        .map(item => ({
          id: item.id,
          name: item.name || '',
          uploadedBy: item.creator?.name || 'Unknown User',
          uploadedDate: item.createdAt
            ? new Date(item.createdAt).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })
            : '',
          createdAt: item.createdAt || 0,
          creatorId: item.creatorId,
        }));

      this.sortArtifacts();
      this.filteredArtifacts = [...this.artifacts];
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error fetching artifacts:', error);
      this.toastrService.error('Failed to load artifacts');
    } finally {
      this.isLoadingArtifacts = false;
      this.cdr.detectChanges();
    }
  }

  /**
   * Sorts artifacts by date
   */
  sortArtifacts(): void {
    if (this.sortOrder === 'latest') {
      this.artifacts.sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateB - dateA;
      });
    } else {
      this.artifacts.sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateA - dateB;
      });
    }
  }

  /**
   * Toggles sort order between latest and oldest
   */
  toggleSortOrder(): void {
    this.sortOrder = this.sortOrder === 'latest' ? 'oldest' : 'latest';
    this.sortArtifacts();
    this.onArtifactSearch();
  }

  onSortOrderChange(newValue: string): void {
    console.log('onSortOrderChange called with:', newValue, 'Current sortOrder:', this.sortOrder);
    const newSortOrder = newValue as 'latest' | 'oldest';

    if (!newSortOrder || newSortOrder === this.sortOrder) {
      console.log('No change needed, returning early');
      return;
    }

    console.log('Updating sort order from', this.sortOrder, 'to', newSortOrder);
    this.isSelecting = true;
    this.previousSortOrder = this.sortOrder;

    // Close dropdown FIRST before updating sort order
    this.isDropdownOpen = false;
    this.cdr.detectChanges();

    // Then update sort order
    this.sortOrder = newSortOrder;
    console.log('Sort order updated to:', this.sortOrder);

    // Sort artifacts first
    console.log('Calling sortArtifacts()');
    this.sortArtifacts();
    console.log('Artifacts sorted, first artifact createdAt:', this.artifacts[0]?.createdAt);

    // Then update filtered artifacts and sort them
    console.log('Calling onArtifactSearch()');
    this.onArtifactSearch();
    console.log(
      'Filtered artifacts updated, count:',
      this.filteredArtifacts.length,
      'first createdAt:',
      this.filteredArtifacts[0]?.createdAt
    );

    // Force change detection immediately - multiple times to ensure UI updates
    this.cdr.detectChanges();
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);

    // Reset selecting flag after a brief delay and ensure dropdown is closed
    setTimeout(() => {
      this.isSelecting = false;
      this.isDropdownOpen = false;
      this.cdr.detectChanges();
    }, 100);
  }

  getSelectValue(): string {
    // Return empty string so change event always fires when selecting
    return '';
  }

  onSelectChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const newValue = target?.value;
    if (newValue) {
      // Set selecting flag to prevent blur from interfering
      this.isSelecting = true;

      // Immediately close dropdown before processing
      this.isDropdownOpen = false;
      this.cdr.detectChanges();

      this.onSortOrderChange(newValue);

      // Reset select value to empty so next selection triggers change event
      setTimeout(() => {
        if (target) {
          target.value = '';
          this.isSelecting = false;
          this.isDropdownOpen = false; // Ensure dropdown stays closed
          this.cdr.detectChanges();
        }
      }, 150);
    }
  }

  onDropdownClick(event: MouseEvent): void {
    event.stopPropagation();
    // Toggle dropdown: if open, close it; if closed, open it
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
      this.cdr.detectChanges();
    } else {
      this.isDropdownOpen = true;
      this.cdr.detectChanges();
    }
  }

  onOptionSelect(value: 'latest' | 'oldest'): void {
    this.onSortOrderChange(value);
  }

  getSortDisplayText(): string {
    // Force check - if selecting, always show closed state
    if (this.isSelecting) {
      return this.sortOrder === 'latest' ? 'Latest > Oldest' : 'Oldest > Latest';
    }
    if (this.isDropdownOpen) {
      return this.sortOrder === 'latest' ? 'Newest' : 'Oldest';
    }
    return this.sortOrder === 'latest' ? 'Latest > Oldest' : 'Oldest > Latest';
  }

  onDropdownFocus(): void {
    // Only open if not currently selecting
    if (!this.isSelecting) {
      this.isDropdownOpen = true;
      this.cdr.detectChanges();
    }
  }

  onDropdownBlur(): void {
    // Always close dropdown on blur, but delay if selecting to allow change event to process
    setTimeout(() => {
      if (!this.isSelecting) {
        this.isDropdownOpen = false;
        this.cdr.detectChanges();
      }
    }, 150);
  }

  /**
   * Searches artifacts by name
   */
  onArtifactSearch(): void {
    if (!this.artifactSearchText.trim()) {
      this.filteredArtifacts = [...this.artifacts];
    } else {
      const searchLower = this.artifactSearchText.toLowerCase();
      this.filteredArtifacts = this.artifacts.filter(artifact => artifact.name.toLowerCase().includes(searchLower));
    }
    // Sort the filtered artifacts based on current sort order
    this.sortFilteredArtifacts();
  }

  /**
   * Sorts filtered artifacts by date
   */
  sortFilteredArtifacts(): void {
    console.log(
      'sortFilteredArtifacts called, sortOrder:',
      this.sortOrder,
      'filteredArtifacts count:',
      this.filteredArtifacts.length
    );
    // Create a new array reference to ensure Angular detects the change
    const sorted = [...this.filteredArtifacts];
    if (this.sortOrder === 'latest') {
      sorted.sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateB - dateA;
      });
      console.log(
        'Sorted latest first, first createdAt:',
        sorted[0]?.createdAt,
        'last createdAt:',
        sorted[sorted.length - 1]?.createdAt
      );
    } else {
      sorted.sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateA - dateB;
      });
      console.log(
        'Sorted oldest first, first createdAt:',
        sorted[0]?.createdAt,
        'last createdAt:',
        sorted[sorted.length - 1]?.createdAt
      );
    }
    this.filteredArtifacts = sorted;
    console.log('filteredArtifacts updated, new reference created');
  }

  /**
   * Toggles artifact selection
   */
  toggleArtifactSelection(artifactId: string): void {
    if (this.selectedArtifacts.has(artifactId)) {
      this.selectedArtifacts.delete(artifactId);
    } else {
      this.selectedArtifacts.add(artifactId);
    }
    this.cdr.detectChanges();
  }

  /**
   * Handles checkbox change event
   */
  onArtifactCheckboxChange(artifactId: string, isChecked: boolean): void {
    if (isChecked) {
      this.selectedArtifacts.add(artifactId);
    } else {
      this.selectedArtifacts.delete(artifactId);
    }
    this.cdr.detectChanges();
  }

  /**
   * Checks if artifact is selected
   */
  isArtifactSelected(artifactId: string): boolean {
    return this.selectedArtifacts.has(artifactId);
  }

  /**
   * Checks if any artifacts are selected
   */
  hasSelectedArtifacts(): boolean {
    return this.selectedArtifacts.size > 0;
  }

  /**
   * Handles linking selected artifacts
   * Emits selected artifact IDs and artifacts array to parent component
   */
  onLinkArtifacts(): Promise<void> {
    if (this.selectedArtifacts.size === 0) {
      this.toastrService.warning('Please select at least one artifact to link');
      return;
    }

    const selectedArtifactIds = Array.from(this.selectedArtifacts);

    // Get selected artifacts with their details
    const selectedArtifactsData = selectedArtifactIds
      .map(id => {
        return this.artifacts.find(a => a.id === id);
      })
      .filter(Boolean);

    // Emit artifact IDs and artifacts data to parent component
    // Linked artifacts have key = artifact.id (no '/' in key), manual uploads have S3 paths (contain '/')
    const artifactsWithKey = selectedArtifactsData.map(artifact => ({
      ...artifact,
      key: artifact.id,
    }));

    this.artifactsLinked.emit({
      artifactIds: selectedArtifactIds,
      artifacts: artifactsWithKey,
    });
    this.closeModal();
  }

  async handleFileInput(filesToUpload: File[]): Promise<void> {
    this.zipSaved = false;
    this.filesToUnUpload = [...filesToUpload];
    const files = [...filesToUpload]; // MaKe a copy before doing any scanning

    for (let i = 0; i < files.length; i++) {
      if (files[i].type === 'application/pdf') {
        if (await this.fileService.scanPdfFile(files[i])) {
          this.toastrService.warning('Your File Contain Malicious Content');
          this.uploader.queue[i]?.remove();
          return;
        }
      }

      if (this.collectionService.isFileControl(this.frameworkName, this.controlName) && !this.checkDocxFile(files[i])) {
        this.uploader.queue[i].remove();
        this.toastrService.warning('Only Docx file(s) can be uploaded on this question');
        return;
      }
      if (FileService.validateFileSize(files[i])) {
        this.uploader.queue[i].remove();
        this.toastrService.warning(files[i].name + ' Size can not be greater than 30MB');
      } else if (!FileService.validateFileType(files[i], FileTypeEnum.ARTIFACTS)) {
        this.uploader.queue[i].remove();
        this.toastrService.warning(files[i].name + ' File type not supported');
      } else {
        this.progressBars = { ...this.progressBars, ...{ [files[i].name]: -1 } };
        this.calculateProgress(files[i].name);
      }
    }

    if (this.uploader.queue.length !== 0) {
      if (this.skipUpload) {
        this.saveFiles.emit({
          files: this.answerDetails.file || [],
          uploadedFiles: files,
          uploadedCount: files.length,
        });
        this.completeAllProgress();
        setTimeout(() => {}, 1000);
      } else {
        // this.startUpload = false;
        this.uploadFiles(files);
      }
    }
  }

  private async uploadFiles(files: File[]): Promise<void> {
    try {
      // storing zipfiles multiple instances
      const zipFiles = (
        await Promise.all(
          Array.from(files).map(async file => {
            if (FileService.validateFileSize(file) || !FileService.validateFileType(file, FileTypeEnum.ARTIFACTS)) {
              return null;
            }
            const fileInstance = new JSZip().file(file.name, file);
            return {
              name: file.name,
              file: (await fileInstance.generateAsync({ type: 'blob' })) as any,
            };
          })
        )
      ).filter(file => UtilsService.isDefined(file));

      const entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');

      if (!UtilsService.isDefined(this.answerDetails.file)) {
        this.answerDetails.file = [];
      }

      // multiple users artifacts: added userId to identify right artifacts
      const currentUserId = this.collectionService.getCurrentUser();

      // Show initial progress toast
      this.toastrService.info('Upload in progress...');

      // Upload zip files to S3 in parallel for better performance
      const s3UploadPromises = zipFiles.map(async zip => {
        try {
          // Generate fileId for each file (this will be used as file.id in answer and childArtifactId in registry)
          const fileId = uuid();
          const s3FileInput: S3FileInput = {
            id: fileId,
            name: zip.name,
            entityId,
            fileType: FileTypeEnum.CLIENT_WIZARD_FILES, // Use this to leverage url property
            contentType: zip.file.type || 'application/octet-stream',
            body: zip.file,
            date: Date.now(),
            url: `ARTIFACTS_REGISTRY/${entityId}/${fileId}`, // Custom path
          };

          // Upload to S3
          const s3Response = await this.fileService.uploadToS3(s3FileInput, false);
          // Ensure the file.id matches the fileId we generated
          s3Response.id = fileId;

          return { s3Response, success: true };
        } catch (error) {
          console.error(`Error uploading file ${zip.name} to S3:`, error);
          return {
            s3Response: null,
            success: false,
            error: `Failed to upload ${zip.name} to S3`,
          };
        }
      });

      // Wait for all S3 uploads to complete
      const s3UploadResults = await Promise.all(s3UploadPromises);

      // Collect successfully uploaded files
      const newFilesS3Responses = s3UploadResults
        .filter(result => result.success && result.s3Response)
        .map(result => result.s3Response);

      // Show errors for failed uploads
      s3UploadResults.forEach(result => {
        if (!result.success && result.error) {
          this.toastrService.error(result.error);
        }
      });

      newFilesS3Responses.forEach(response => {
        response.userId = currentUserId?.id;
      });

      this.answerDetails.file = [...this.answerDetails.file, ...newFilesS3Responses];

      this.completeAllProgress();

      this.saveFiles.emit({
        files: this.answerDetails.file,
        uploadedFiles: newFilesS3Responses, // Only newly uploaded files
        uploadedCount: newFilesS3Responses.length,
      });
      this.closeModal();
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('Failed to Upload files');
    }
  }

  calculateProgress(name: string): void {
    const x = setInterval(() => {
      this.progressBars[name] += 10;
      if (this.zipSaved) {
        this.progressBars[name] = this.progressBars[name] + (99 - this.progressBars[name]);
      }
      if (this.progressBars[name] >= 100) {
        clearInterval(x);
      }
    }, 1000);
  }

  completeAllProgress(): void {
    this.zipSaved = true;
    setTimeout(() => {
      this.zipSaved = false;
    }, 1000);
  }
  closeModal(): void {
    if (!this.startUpload) {
      this.deleteFiles(this.filesToUnUpload);
    }
    this.filesToUnUpload = [];
    this.uploadModalScreen = false;
    this.closeModalClicked.emit(true);
  }

  /**
   * @param filesToDelete list of object{fileId,questionId,answerId}
   *  This function delete the files which already exist with same name
   */
  deleteFiles(filesToDelete: any[]): void {
    if (filesToDelete?.length) {
      this.collectionService.deleteArtifacts(filesToDelete);
    }
  }

  /**
   * Function to check if the given file is Document or not
   * As some questions should only have Docx artifacts (for reports)
   * @param file
   * @returns true if the file is docx else false
   */
  checkDocxFile(file): boolean {
    return file.type === this.DOCX;
  }

  /**
   * Triggers file input click when drag area is clicked
   */
  onDragAreaClick(): void {
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.click();
    }
  }

  /**
   * Checks if question text is truncated (exceeds max-height)
   */
  isQuestionTextTruncated(): boolean {
    if (!this.questionTextElement?.nativeElement || !this.questionText) {
      return false;
    }
    try {
      const element = this.questionTextElement.nativeElement;
      // Check if content exceeds the max-height (7vh)
      return element.scrollHeight > element.clientHeight;
    } catch (e) {
      return false;
    }
  }
}
